import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SIcon from "../../NUI/StreamlineIcons/SIcon";
export function Message({ variant = "default", clsn, header, content, icon, color, children }) {
    const variantCls = {
        default: "bg-gray-100",
        warning: "bg-yellow-50",
        error: "bg-red-50",
        success: "bg-is-green-20",
        info: "bg-is-blue-20",
    };
    const textClr = (color === "pink" && "text-[#e03997]") || (color === "red" && "text-[#db2828]") || "text-black";
    return (_jsxs("div", { className: `${clsn} flex flex-col flex-1 mb-2 min-h-[56px] justify-center p-4 relative rounded-sm shadow ${textClr} ${variantCls[variant]}`, children: [_jsxs("div", { className: "flex text-left w-full", children: [icon && _jsx(SIcon, { name: icon, size: "s", bold: true }), _jsx("span", { className: "font-bold", children: header })] }), children !== null && children !== void 0 ? children : content] }));
}
